<template>
	<div class="pic-popup">
		<van-dialog v-model="showFlag" :show-confirm-button="false" :show-cancel-button="false" class="picture">
			<div class="picBox">
				<img src="../../../assets/img/inviteImg.jpg" alt="" class="img" />
			</div>
		</van-dialog>
		<div v-if="showFlag" class="closeIcon iconfont icon-2guanbi" @click="close"></div>
	</div>
</template>

<script>
import popup from '@extend/components/popup';
export default {
	name: 'picture-popup',
	components: {
		popup,
	},
	data() {
		return {
			showFlag: false,
		};
	},
	methods: {
		open() {
			this.showFlag = true;
		},
		close() {
			this.showFlag = false;
		},
	},
};
</script>

<style lang="scss">
.pic-popup {
	.picture {
		width: 55.68vw !important;
		height: 35.81vw !important;
		.van-dialog__content {
			width: 100%;
			height: 100%;
		}
	}
}
</style>

<style lang="scss" scoped>
.picture {
	.picBox {
		width: 100%;
		height: 100%;
		.img {
			width: 100%;
			height: 100%;
			display: block;
		}
	}
}
.closeIcon {
	position: fixed;
	top: 65%;
	margin-top: 10vw;
	left: 50%;
	cursor: pointer;
	z-index: 99999;
	font-size: 30px;
	color: #fff;
	margin-left: -15px;
}
</style>
